module.exports = __webpack_public_path__ + "img/mada.13fd0c35.svg";